import React from 'react';
import { useTranslation } from 'react-i18next';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload as AntdUpload, UploadFile } from 'antd-v5';
import { UploadFileStatus } from 'antd-v5/es/upload/interface';
import { RcFile } from 'antd-v5/lib/upload';
import { UploadWrapper } from 'components/FileUploadButton/Upload.styled';

export interface UploadFileState {
  uidLocal: string;
  key?: string;
  fileName: string;
  extension: string;
  base64?: string;
  status: UploadFileStatus;
  error?: string;
}

interface UploadProps {
  showUploadList?: boolean;
  fileList?: UploadFile[];
  fileListType?: 'diagonal' | 'vertical';
  onRemove?: (file: UploadFile) => void;
  handleUpload: (file: RcFile) => Promise<void>;
}

const Upload = ({ showUploadList, fileListType = 'vertical', handleUpload, fileList, onRemove }: UploadProps) => {
  const { t } = useTranslation();
  return (
    <UploadWrapper fileListType={fileListType}>
      <AntdUpload
        beforeUpload={(file) => {
          handleUpload(file);
          return false;
        }}
        showUploadList={showUploadList}
        fileList={fileList}
        onRemove={onRemove}
        onPreview={() => undefined}
      >
        <Button icon={<UploadOutlined />}>{t('common.action.upload', 'Upload')}</Button>
      </AntdUpload>
    </UploadWrapper>
  );
};

export default Upload;
